class Supervision {
	constructor() {

		this._newDialog = Dialog.Modal('supervision', _("New supervised user"), LARGE, _("CREATE HERO"), [
			this._form = htm('form', 'container-fluid', [
				div('row', [
					div('col', [
						span('small', _('First and last name')),
						this._fullName = text('form-control', null, null, {
							'aria-label': 'First and last name',
							'data-validate': 'required name'
						})
					])
				]),
				div('row', [
					div('col', [
						span('small', _('Username')),
						this._username = text('form-control', null, null, {
							'placeholder': _('Optional if email address entered'),
							'data-validate': 'reqWithoutEmail username usernameUsed'
						})
					])
				]),
				div('row', div('col', [
					span('small', _('Email address')),
					this._email = text('form-control', null, null, {
						'placeholder': _('Optional if username entered'),
						'data-validate': 'reqWithoutUsername email emailUsed'
					})
				])),
				div('row', div('col', [
					span('small', _('Password')),
					this._password = input('password', 'form-control', null, null, {
						'data-required': _('Password is required'),
						'data-validate': 'password'
					})
				])),
				div('row', [
					div('col', [
						label('form-label', _("Subscription option:")),
						this._subOption = htm('select', 'form-select', null, null, null, {
							'aria-label': _("Choose subscription option")
						})
					])
				])
			])
		]);

		this.validation = new Validate(this._form, this._newDialog.affirmButton);
	}

	openNewForm() {
		this._newDialog.open(this.createNewSupervised.bind(this));
		this._fullName.value = '';
		this._username.value = '';
		this._email.value = '';
		this._password.value = '';
		this._subOption.innerHTML = '';
		this._fullName.focus();
		ajg('supervision/init', null, null, (reply)=>{
			if (reply.options && Array.isArray(reply.options)) {
				for (let op of reply.options) {
					this._subOption.appendChild(option(op.text, op.id));
				}
			}
		}, this);
	}

	createNewSupervised() {
		API.post(
			'users',
			{
				name: this._fullName.value,
				username: this._username.value,
				emailAddress: this._email.value,
				password: this._password.value,
				subscription: this._subOption.value
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			document.dispatchEvent(new Event('primaryDataInvalid'));
		});
	}

	requestSupervision(userId) {
		Dialog.Confirm(
			_("Confirm you want to ask for supervision. <br?> They will have full control of your account!!"),
			_("REQUEST SUPERVISION"),
			() => {
				ajg('supervision/request', ['userId=' + encodeURI(userId)], null, (reply) => {
					showError(reply);
				})
			}
		);
	}

	stopSupervising(userId) {
		Dialog.Confirm(
			_("If you stop supervising this hero, you can only do so again by their request. <br/> Are you sure!"),
			_("STOP SUPERVISING"),
			() => {
				ajg('supervision/stop', ['userId='+encodeURI(userId)], null, (reply) => {
					if (showError(reply)) return;
					document.dispatchEvent(new Event('primaryDataInvalid'));
				})
			}
		);
	}
}